import Vue from 'vue';
import store from '../../vuex/store';

const state =
{
    mobile: false,
    viewport: null,
    hasNavigation: false,
    hasFooterBar: false,
    rosterView: null,
    mainContentHeight: null,
};

const actions =
{
    setViewport ({commit})
    {
        commit('SET_VIEWPORT');
    },

    toggleNavigation ({commit})
    {
        commit('TOGGLE_NAVIGATION');
    },

    showNavigation ({commit})
    {
        commit('SHOW_NAVIGATION');
    },

    hideNavigation ({commit})
    {
        commit('HIDE_NAVIGATION');
    },

    showFooterBar ({commit})
    {
        commit('SHOW_FOOTER_BAR');
    },

    hideFooterBar ({commit})
    {
        commit('HIDE_FOOTER_BAR');
    },

    setMainContentHeight ({commit})
    {
        let main = document.querySelector('.content'),
            height = 0;

        if (main) height = main.clientHeight;

        commit('SET_MAIN_CONTENT_HEIGHT', height);
    },

    rosterView ({commit}, payload)
    {
        let value = payload,
            update = true;

        if (typeof payload === 'object')
        {
            update = payload.update;
            value = payload.value;
        }

        if (update)
        {
            Vue.http.put('/api/memberships/' + store.state.current.membership.id + '/preferences', {
                key: 'roster.view',
                value: value
            });
        }

        commit('ROSTER_VIEW', value);
    },
};

const mutations =
{
    SET_VIEWPORT (state)
    {
        let width = window.innerWidth;

        if (width <= 400) {
            state.viewport = 'mp';
        } else if (width <= 600) {
            state.viewport = 'ml';
        } else if (width <= 800) {
            state.viewport = 'tp';
        } else if (width <= 1200) {
            state.viewport = 'tl';
        } else {
            state.viewport = 'd';
        }

        state.mobile = state.viewport != 'd' && state.viewport != 'tl';
    },

    TOGGLE_NAVIGATION (state)
    {
        state.hasNavigation = ! state.hasNavigation;
    },

    SHOW_NAVIGATION (state)
    {
        state.hasNavigation = true;
    },

    HIDE_NAVIGATION (state)
    {
        state.hasNavigation = false;
    },

    SHOW_FOOTER_BAR (state)
    {
        state.hasFooterBar = true;
    },

    HIDE_FOOTER_BAR (state)
    {
        state.hasFooterBar = false;
    },

    ROSTER_VIEW (state, value)
    {
        state.rosterView = value;
    },

    SET_MAIN_CONTENT_HEIGHT (state, value)
    {
        state.mainContentHeight = value;
    }
};

export default
{
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/js/vuex/modules/layout.js